import { FormattedImageListType, OptionType } from '../../utils/@globalTypes';
import {
  LimitWithOffsetPayload,
  PayloadDataWithId,
  PayloadWithCallback,
  ResponseData,
  ResponseOptionsData,
} from './@types';
import { MainObject, ObjectTypeData } from './mainObjectTypes';
import { CertainDayPriceTypeList, BasePriceType } from './pricesTypes';
import { SelectState } from './bookingTypes';

// STATE TYPES

export enum RentalObjectStatusesEnum {
  AFB = 'afb',
  CFB = 'cfb',
  MNT = 'mnt',
}

export type RentalObject = {
  id: number;
  main_object: MainObject;
  name: string;
  description: string | null;
  short_description: string;
  status: string;
  max_places: number | null;
  object_type: OptionType;
  image: RentalImage | null;
};

export type RentalObjectList = RentalObject[];

export type FeatureType = {
  name: string;
  logo: string;
};

export type RentalObjectFeature = FeatureType & {
  id: number;
};

export type RentalObjectFeaturesList = RentalObjectFeature[];

export type CurrentRentalObject = {
  id: number;
  main_object: {
    id: string;
    name: string;
    object_type: ObjectTypeData;
  };
  name: string;
  object_type: ResponseOptionsData;
  description: string | null;
  short_description: string;
  status: string;
  max_places: number | null;
  image: string | null;
  price: BasePriceType;
  certain_day_prices: CertainDayPriceTypeList;
  booking_setting: {
    check_in: string;
    check_out: string;
    is_check_in_out_time_restricted: boolean;
    min_days_high_season: number;
    min_days_low_season: number;
  };
};

export type BedType = {
  double_bed: number;
  single_bed: number;
  children_bed: number;
  extra_sleeping_place: number;
};

export type RentalImage = {
  id: number;
  image: string;
  order: string;
  rental_object: number;
};

export type RentalImagesList = RentalImage[];

// PAYLOAD TYPES

export type CreateRentalObjectPayload = {
  name: string;
  main_object: string;
  object_type: number;
};

export type UpdateRentalObjectData = {
  name?: string;
  description?: string;
  short_description?: string;
  max_places?: number;
  object_type?: number;
  status?: string;
  features?: FeatureType[];
};

export type UpdateRentalImagesData = {
  images: FormattedImageListType;
  rental_object: number;
  removedIdList: number[];
  clearRemovedListCallback: () => void;
};

export type UpdateRentalImagesPayload = {
  old_images: number[];
  old_images_orders: number[];
  new_images: File[];
  new_images_orders: number[];
  rental_object: number;
};

export type UpdateRentalObjectAllBasicSettingsPayload = {
  info?: UpdateRentalObjectPayload;
  images?: UpdateRentalImagesData;
};

export type UpdateRentalObjectPayload =
  PayloadDataWithId<UpdateRentalObjectData>;

export type CreateRentalObjectPayloadData =
  PayloadWithCallback<CreateRentalObjectPayload>;

export type GetRentalObjectListPayload = LimitWithOffsetPayload & {
  main_object: string;
};

// RESPONSE TYPES

export type RentalObjectsResponseData = ResponseData<RentalObjectList>;

export type RentalObjectTypesResponseData = ResponseData<ResponseOptionsData[]>;
export type RentalObjectFeaturesResponseData = RentalObjectFeaturesList;

export type BasicRentalForm = {
  name: string;
  description: string;
  short_description: string;
  status: string;
  max_places: number;
  object_type: OptionType | null;
  features: SelectState[];
  rentalImage: string[];
  newRentalImage?: RentalImage[];
};
